export const $_app_sessionDoc = {
  methods: {
    $_sessionDoc_open (d, target) {
      console.log('OPEN', d.sendable.result)
      if (d.sendable && d.sendable.result) {
        window.open(d.sendable.result, target)  
        // let win = window.open(d.sendable.result, target)  
        // setTimeout(this.closeWin(win), 1500)
      }
      
    },

    closeWin(win) {
      win.close();
    },

    $_sessionDoc_openAll (list) {
      list.forEach(d => {
        this.$_sessionDoc_open(d, '_blank')
      })
    }
  }
}

export default $_app_sessionDoc